import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    SelectInput,
    SelectField,
    NumberInput,
    DateInput,
    ReferenceArrayInput,
    SelectArrayInput,
    Filter,
    DateField
} from 'react-admin';

import { required, maxLength, minLength, number } from './../../utils/validations';

const choices = [
    { id: "WALLET_CASH", name: "Wallet Cashback" },
    { id: "CASH", name: "Discount" },
];

const CouponFilter = (props) => (
    <Filter {...props}>
        <TextInput source="code" label="Code" />
    </Filter>
);

export const CouponList = (props) => (
    <List {...props} title="Coupons" bulkActionButtons={false}
        filters={<CouponFilter />} filter={{ cityId: sessionStorage.getItem("cityId") }}
        sort={{ field: "creationTime", order: "DESC" }}>
        <Datagrid>
            <TextField source="code" label="Code" />
            <TextField source="maxUsage" label="Max Usage" />
            <TextField source="minOrderAmount" label="Min Order Amount" />
            <TextField source="maxDiscountAmount" label="Max Discount Amount" />
            <TextField source="discountPercentage" label="Discount Percentage" />
            <TextField source="validFrom" label="From Date" />
            <TextField source="validTo" label="To Date" />
            <SelectField source="discountType"
                choices={choices}
                label="Discount Type" />
            <DateField source="creationTime" label="Creation Time" showTime />
            <EditButton />
        </Datagrid>
    </List>
);

const validateName = [required(), minLength(2), maxLength(30)];
const validateNumber = [required(), number()];

const defaultValues = {
    cityId: sessionStorage.getItem("cityId")
};

export const CouponEdit = (props) => (
    <Edit title="Edit Coupon" {...props}>
        <SimpleForm redirect="list" {...props} defaultValue={defaultValues}>
            <TextInput label="Code" source="code" validate={validateName} />
            <NumberInput label="Max Usage" source="maxUsage" validate={validateNumber} />
            <NumberInput label="Minimum Order Amount" source="minOrderAmount" validate={validateNumber} />
            <NumberInput label="Max Discount Amount" source="maxDiscountAmount" validate={validateNumber} />
            <NumberInput label="Discount Percentage" source="discountPercentage" validate={validateNumber} />
            <DateInput label="From Date" source="validFrom" validate={required()} />
            <DateInput label="To Date" source="validTo" validate={required()} />
            <SelectInput source="discountType" choices={choices} validate={required()} />
            <ReferenceArrayInput
                source="merchantIds"
                reference="ct/merchants"
                label="Merchants"
                perPage={100}
                allowEmpty>
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const CouponCreate = (props) => (
    <Create title="Create Coupon" {...props}>
        <SimpleForm redirect="list">
            <TextInput label="Code" source="code" validate={validateName} />
            <NumberInput label="Max Usage" source="maxUsage" validate={validateNumber} />
            <NumberInput label="Minimum Order Amount" source="minOrderAmount" validate={validateNumber} />
            <NumberInput label="Max Discount Amount" source="maxDiscountAmount" validate={validateNumber} />
            <NumberInput label="Discount Percentage" source="discountPercentage" validate={validateNumber} />
            <DateInput label="From Date" source="validFrom" validate={required()} />
            <DateInput label="To Date" source="validTo" validate={required()} />
            <NumberInput
                label="From Hour"
                source="hourFrom"
                validate={validateNumber}
                defaultValue={6}
            />
            <NumberInput
                label="To Hour"
                source="hourTo"
                validate={validateNumber}
                defaultValue={23}
            />
            <SelectInput source="discountType" choices={choices} validate={required()} />
            <SelectInput source="cityId" validate={required()} choices={[
                { id: sessionStorage.getItem("cityId"), name: sessionStorage.getItem("cityName") }
            ]} />

            <ReferenceArrayInput
                source="merchantIds"
                reference="ct/merchants"
                label="Merchants"
                perPage={100}
                allowEmpty>
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
)
